import Http from "../commons/utils/Http";
import {errorHandling} from "../commons/utils/error";

class PartnersService {

    async getAll(page, order ='codparc') {
        try {
            let response = await Http.get(`/partners/get-all?offset=${page}&order=${order}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/partners/get-by?field=id&value=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getByUser(id) {
        try {
            let response = await Http.get(`/partners/partnersusers?user_id=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(search) {
        try {
            let response = await Http.get(`/partners/search?search=${search}`,Http.headers)
            return response
        } catch (e) {
            
        }
    }

    async getRolesChecked(id_partner,id_user) {
        try {
            let response = await Http.get(`/partners/puar?partner_id=${id_partner}&user_id=${id_user}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getApplications(id) {
        try {
            let response = await Http.get(`partners/products-by-partner?partner_id=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }
}

export default new PartnersService();
